var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","padding":"80px 20px 20px 20px"}},[_c('img',{staticStyle:{"width":"109px","height":"109px"},attrs:{"src":require("../../assets/img/store/img_gzrw@3x.png")}}),_c('div',{staticStyle:{"font-size":"16px"}},[_vm._v("正在为您配置，请耐心等待~")])])
}]

export { render, staticRenderFns }